import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { DatePicker, MuiPickersContext } from '@material-ui/pickers';
import classNames from 'classnames';
import { useStyles as useOriginalStyles } from '@material-ui/pickers/views/Calendar/Day';

const useStyles = makeStyles(() => ({
  day: {
    margin: 0,
    width: 40,
    borderRadius: 0,
  },
  beginCap: {
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  },
  endCap: {
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
  },
}), { name: 'DateRangePicker' });

// Tweaked version of:
// https://github.com/mui-org/material-ui-pickers/issues/364#issuecomment-496021379
function DateRangePicker({
  value,
  onChange,
  labelFunc,
  format,
  emptyLabel,
  autoOk,
  onClose,
  ...props
}) {
  const [ begin, setBegin ] = useState(value[0]);
  const [ end, setEnd ] = useState(value[1]);
  const [ hover, setHover ] = useState(undefined);
  const originalClasses = useOriginalStyles();
  const classes = useStyles();
  const utils = useContext(MuiPickersContext);

  const min = Math.min(begin, end || hover);
  const max = Math.max(begin, end || hover);

  function renderDay(day, selectedDate, dayInCurrentMonth, dayComponent) {
    return React.cloneElement(dayComponent, {
      onClick: e => {
        e.stopPropagation();
        if (!begin) setBegin(day);
        else if (!end) {
          setEnd(day);
        } else {
          setBegin(day);
          setEnd(undefined);
        }
      },
      onMouseEnter: e => setHover(day),
      className: classNames(originalClasses.day, classes.day, {
        [originalClasses.hidden]: dayComponent.props.hidden,
        [originalClasses.current]: dayComponent.props.current,
        [originalClasses.dayDisabled]: dayComponent.props.disabled,
        [originalClasses.daySelected]: utils.isSameDay(day, min) || utils.isSameDay(day, max) || (day >= min && day <= max),
        [classes.beginCap]: utils.isSameDay(day, min),
        [classes.endCap]: utils.isSameDay(day, max),
      }),
    });
  }

  const formatDate = date => utils.format(date, format || utils.dateFormat);

  return (
    <DatePicker
      {...props}
      fullWidth
      value={begin}
      renderDay={renderDay}
      onClose={onClose}
      onChange={date => {
        if (begin && !end) {
          onChange([begin, begin])
        } else if (!begin && end) {
          onChange([end, end])
        } else {
          onChange([begin, end].sort((a, b) => a - b));
        }
      }}
      onClear={() => {
        setBegin(undefined);
        setEnd(undefined);
        setHover(undefined);
        onChange([]);
      }}
      labelFunc={(date, invalid) =>
        labelFunc
          ? labelFunc([begin, end].sort((a, b) => a - b), invalid)
          : date && begin && end
          ? [begin, end].sort((a, b) => a - b).map(formatDate).join(" - ")
          : emptyLabel || ""
      }
      className="date-range-picker"
    />
  );
}

export default DateRangePicker;
